module.exports = __webpack_public_path__ + "static/img/manual-8.b26db6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-8.png
// module id = kDIV
// module chunks = 4